import Link from "next/link";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

const ResultsContainer = ({ data }) => {
  return (
    <section
      className="bg-light-blue-grey lg:-mt-10 lg:pt-20 md:pb-5 md:pt-7"
      id="results-container"
    >
      <div
        className="container card--default card--showcase has-three-col fx--sa has-gutter-md c-padding custom-size search-results"
        id="results"
      >
        {data.map((page, index) => (
          <Link
            href={page.href}
            key={index}
            prefetch={false}
            className="hover-review-card integration-tile"
            id={page.id}
          >
            <figure dangerouslySetInnerHTML={{ __html: page.icon }}></figure>
            <div>
              <h3>{page.heading}</h3>
              <p>{page.desc}</p>
            </div>
            <style global jsx>{`
              #no-box-shadow {
                border: 1px solid ${colors.primitive.black[300]};
                box-shadow: none;
                background-color: transparent;
                align-items: center;
              }
              #no-box-shadow figure {
                display: none;
              }
              #no-box-shadow div {
                text-align: center;
                margin-right: auto;
                margin-left: auto;
              }
              #no-box-shadow h3 {
                font-size: ${font.size.md[1]};
                line-height: ${lineHeight[7]};
                font-weight: ${font.weight.normal};
                color: ${colors.derived.primary};
              }
              #no-box-shadow p {
                font-size: ${font.size.md[1]};
                line-height: ${lineHeight[7]};
                color: ${colors.derived.brand};
              }
            `}</style>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ResultsContainer;
